import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import DashboardLayout from "../DashboardLayout";
import Dashboard from "../../pages/Dashboard";
import Blogs from "../../pages/Blogs";
import Category from "../../pages/Category";
import Tags from "../../pages/Tags";
import Status from "../../pages/Status";
import Users from "../../pages/Users";
import Role from "../../pages/Role";
import ProfileSetting from "../../pages/ProfileSetting";

export default function AdminApp({ basePath = "admin" }) {
  return (
    <DashboardLayout basePath={basePath}>
      <Routes>
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="blogs" element={<Blogs />} />
        <Route path="category" element={<Category />} />
        <Route path="tags" element={<Tags />} />
        <Route path="status" element={<Status />} />
        <Route path="users" element={<Users />} />
        <Route path="roles" element={<Role />} />
        <Route path="profile" element={<ProfileSetting />} />
        <Route path="*" element={<Navigate to="dashboard" replace />} />
      </Routes>
    </DashboardLayout>
  );
}
